import { useTracker } from '../lib/useTracker';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthProvider';
import { useScreen } from '../lib/useScreen';
import { useTheme } from '../lib/useTheme';
import UserAvatar from '../lib/UserAvatar';
import { supabase } from '../lib/supabaseClient';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)', triGrad:'linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b)' };
const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";

const HISTORIAS = [
  {
    autor:'Mariana G.', tiempo:'3 min de lectura',
    titulo:'Cosía bolsas en mi cuarto con la puerta cerrada porque me daba vergüenza',
    preview:'No era que no creyera en lo que hacía. Era que tenía miedo de que los demás no creyeran. Cada puntada era una conversación conmigo misma: "¿y si se ríen?", "¿y si nadie compra?". Cerraba la puerta no por privacidad, sino por protección. Porque si nadie veía, nadie podía opinar.',
  },
  {
    autor:'Carlos R.', tiempo:'5 min de lectura',
    titulo:'El día que abrí mi café y no vino nadie',
    preview:'Puse las sillas. Prendí la cafetera. Limpié la barra tres veces. Y esperé. Las 9. Las 10. Las 11. Nadie. Mi esposa me mandó un mensaje: "¿cómo va?" y no supe qué contestar. No era tristeza. Era algo peor: la sensación de haber apostado todo y que el universo no respondiera.',
  },
  {
    autor:'Andrea M.', tiempo:'4 min de lectura',
    titulo:'Le dije a mi familia que iba a vender postres y se quedaron en silencio',
    preview:'Ese silencio fue peor que un "no". Porque en ese silencio escuché todo lo que pensaban pero no decían. Que era riesgoso. Que no era un trabajo de verdad. Que iba a fracasar. Y lo peor es que una parte de mí pensaba lo mismo.',
  },
  {
    autor:'Roberto L.', tiempo:'6 min de lectura',
    titulo:'Lloré en el carro después de una junta con mi socio',
    preview:'No por lo que me dijo. Sino porque tenía razón. Me dijo que estaba haciendo todo solo porque no confiaba en nadie. Y era cierto. Llevaba meses cargando un peso que no era solo mío pero que me negaba a soltar. El carro se convirtió en el único lugar donde podía ser honesto.',
  },
  {
    autor:'Patricia N.', tiempo:'3 min de lectura',
    titulo:'Hoy mi hija me dijo "mami, quiero ser como tú"',
    preview:'Y no fue por el dinero ni por el negocio. Fue porque me vio sentada en la mesa a las 6 de la mañana haciendo algo que me gusta. No sé si este negocio va a funcionar. Pero sé que mi hija me vio intentarlo. Y eso ya valió todo.',
  },
];

function timeAgo(date) {
  const s = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
  if (s < 60) return 'ahora';
  if (s < 3600) return `hace ${Math.floor(s/60)} min`;
  if (s < 86400) return `hace ${Math.floor(s/3600)}h`;
  if (s < 604800) return `hace ${Math.floor(s/86400)}d`;
  return new Date(date).toLocaleDateString('es-MX', { day:'numeric', month:'short' });
}

function Separator() {
  return <div style={{ width:40, height:2, borderRadius:1, background:C.triGrad, opacity:0.3, margin:'0 auto' }}/>;
}

export default function HumanStories() {
  const navigate = useNavigate();
  const { user, profile, membership, signOut } = useAuth();
  useTracker("stories", user?.id);
  const { isMobile } = useScreen();
  const t = useTheme();
  const [showModal, setShowModal] = useState(false);
  /* editor moved to /stories/escribir */
  const [realStories, setRealStories] = useState([]);
  const [publishing, setPublishing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [draft, setDraft] = useState(null);
  const [autoSaved, setAutoSaved] = useState(false);
  const [refresh, setRefresh] = useState(0);

  const esFree = membership === 'free_observer';
  const nombre = user?.user_metadata?.full_name?.split(' ')[0] || 'ahí';

  const [drafts, setDrafts] = useState([]);

  // Load published stories + user's drafts
  React.useEffect(() => {
    if (!user) return;
    supabase.from('stories').select('*')
      .or(`status.eq.published,status.is.null`)
      .order('created_at', { ascending: false })
      .then(({ data }) => { if (data) setRealStories(data); });
    supabase.from('stories').select('*')
      .eq('user_id', user.id).eq('status', 'draft')
      .order('updated_at', { ascending: false })
      .then(({ data }) => { if (data) { setDrafts(data); setDraft(data[0] || null); } });
  }, [user, refresh]);

  const handleEscribir = () => {
    if (esFree) { setShowModal(true); return; }
    navigate('/stories/escribir');
  };

  /* saveStory + auto-save moved to EscribirHistoria page */

  const deleteStory = async (id) => {
    await supabase.from('stories').delete().eq('id', id);
    setRefresh(r => r + 1);
  };

  const editStory = (s) => {
    setStoryTitle(s.title); setStoryContent(s.content); setEditingId(s.id); setShowEditor(true);
  };

  const allStories = [...realStories.map(s => ({ ...s, isReal:true })), ...HISTORIAS.map((h,i) => ({ id:'mock-'+i, title:h.titulo, content:h.preview, author_name:h.autor, author_business:'', created_at:'', tiempo:h.tiempo }))];

  return (
    <div style={{ background:t.bg, fontFamily:font, color:t.text, minHeight:'100vh', overflowWrap:'break-word' }}>

      {/* NAV */}
      <nav style={{ position:'sticky', top:0, zIndex:100, background:t.navBg, backdropFilter:'blur(12px)', borderBottom:`0.5px solid ${t.border}` }}>
        <div style={{ maxWidth:640, margin:'0 auto', padding:'0 1.5rem', height:60, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <button onClick={() => navigate('/sala')} style={{ background:'none', border:'none', color:C.turquesa, fontSize:14, fontWeight:500, cursor:'pointer', fontFamily:font }}>← La Sala</button>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <UserAvatar url={profile?.avatar_url} name={nombre} size={28}/>
            <button onClick={()=>navigate('/perfil')} style={{ background:'none', border:'none', color:t?.textSecondary||'#999', fontSize:12, cursor:'pointer', fontFamily:"'DM Sans', sans-serif", padding:'4px 8px' }}>Mi perfil</button>
            <button onClick={async () => { await signOut(); navigate('/'); }} style={{ background:'none', border:`0.5px solid ${t.border}`, color:t.textSecondary, borderRadius:50, padding:'5px 14px', fontSize:12, cursor:'pointer', fontFamily:font }}>Salir</button>
          </div>
        </div>
      </nav>

      <div style={{ maxWidth:640, margin:'0 auto', padding:isMobile ? '2rem 1rem' : '3rem 1.5rem' }}>

        {/* MIS BORRADORES */}
        {drafts.length > 0 && (
          <div style={{ marginBottom:28 }}>
            <p style={{ fontSize:13, color:C.mango, fontWeight:600, letterSpacing:1.5, margin:'0 0 10px' }}>📝 MIS BORRADORES</p>
            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {drafts.map(d => (
                <div key={d.id} style={{ background:t.card, border:`1px solid rgba(253,190,2,0.15)`, borderRadius:14, padding:'14px 16px', display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ flex:1, minWidth:0 }}>
                    <p style={{ fontSize:14, fontWeight:500, margin:'0 0 2px', color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{d.title || 'Sin título'}</p>
                    <p style={{ fontSize:11, color:t.textSecondary, margin:0 }}>Borrador · Guardado {d.updated_at ? timeAgo(d.updated_at) : ''}</p>
                  </div>
                  <button onClick={()=>navigate(`/stories/escribir?draft=${d.id}`)} style={{ background:'rgba(253,190,2,0.1)', border:'1px solid rgba(253,190,2,0.2)', borderRadius:50, padding:'7px 14px', fontSize:12, fontWeight:500, color:C.mango, cursor:'pointer', fontFamily:font, whiteSpace:'nowrap' }}>Continuar →</button>
                  <button onClick={async()=>{ if(!window.confirm('¿Eliminar este borrador?'))return; await supabase.from('stories').delete().eq('id',d.id); setRefresh(r=>r+1); }} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.2)', fontSize:16, cursor:'pointer', padding:'0 4px' }}>×</button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* HEADER */}
        <header style={{ textAlign:'center', marginBottom:isMobile ? '2.5rem' : '3.5rem' }}>
          <p style={{ fontSize:12, color:C.turquesa, fontWeight:600, letterSpacing:2.5, marginBottom:16 }}>HUMAN STORIES & IDEAS</p>
          <h1 style={{ fontFamily:serif, fontSize:isMobile ? 24 : 30, fontWeight:400, lineHeight:1.3, marginBottom:16 }}>
            Escribir es recordar quién eres cuando el ruido se apaga.
          </h1>
          <p style={{ fontSize:isMobile ? 14 : 15, color:t.textSecondary, lineHeight:1.8, marginBottom:28, maxWidth:480, marginLeft:'auto', marginRight:'auto' }}>
            Este no es un lugar para presumir logros. Es un espacio para lo que sientes de verdad. Para los miedos que no le cuentas a nadie. Para esa satisfacción pequeña que nadie más vio. Aquí no hay likes. Solo honestidad.
          </p>
          <button className="td-glow-btn" onClick={handleEscribir} style={{
            background:C.logoGrad, color:'#fff', border:'none', borderRadius:50,
            padding:'12px 32px', fontSize:15, fontWeight:500, cursor:'pointer', fontFamily:font,
            boxShadow:'0 4px 15px rgba(83,74,183,0.2)',
            transition:'transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform='translateY(-3px) scale(1.03)'; e.currentTarget.style.boxShadow='0 10px 30px rgba(83,74,183,0.3)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform='translateY(0) scale(1)'; e.currentTarget.style.boxShadow='0 4px 15px rgba(83,74,183,0.2)'; }}
          >Escribir historia</button>
        </header>

        {/* HISTORIAS */}
        <div>
          {allStories.map((s, i) => (
            <div key={s.id}>
              {i > 0 && <div style={{ padding:'1.5rem 0' }}><Separator /></div>}
              <article style={{ paddingBottom:'1rem' }}>
                <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
                  <div style={{ width:36, height:36, borderRadius:'50%', background:C.triGrad, display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:14, fontWeight:700 }}>
                    {(s.author_name||'A').charAt(0)}
                  </div>
                  <div style={{ flex:1 }}>
                    <p style={{ fontSize:14, fontWeight:500, margin:0 }}>{s.author_name}</p>
                    <p style={{ fontSize:12, color:t.textSecondary, margin:0 }}>{s.created_at ? new Date(s.created_at).toLocaleDateString('es-MX') : s.tiempo||''}</p>
                  </div>
                  {s.isReal && s.user_id === user?.id && (
                    <div style={{ display:'flex', gap:6 }}>
                      <button onClick={()=>editStory(s)} style={{ background:'none', border:'none', color:C.turquesa, fontSize:12, cursor:'pointer', fontFamily:font }}>Editar</button>
                      <button onClick={()=>deleteStory(s.id)} style={{ background:'none', border:'none', color:C.coral, fontSize:12, cursor:'pointer', fontFamily:font }}>Eliminar</button>
                    </div>
                  )}
                </div>
                <h2 style={{ fontFamily:serif, fontSize:isMobile?18:20, fontWeight:400, lineHeight:1.35, marginBottom:12 }}>{s.title}</h2>
                <p style={{ fontSize:isMobile?14:15, color:t.textSecondary, lineHeight:1.8, marginBottom:12 }}>{s.content}</p>
              </article>
            </div>
          ))}
        </div>

        {/* Editor moved to /stories/escribir */}

        {/* CTA */}
        <div style={{ textAlign:'center', padding:isMobile ? '2.5rem 0 2rem' : '3.5rem 0 2rem' }}>
          <Separator />
          <div style={{ paddingTop:'2rem' }}>
            <h2 style={{ fontFamily:serif, fontSize:isMobile ? 20 : 24, fontWeight:400, lineHeight:1.35, marginBottom:12 }}>
              Lo que escribes hoy puede ser exactamente lo que alguien necesita leer mañana.
            </h2>
            <p style={{ fontSize:14, color:t.textSecondary, marginBottom:24 }}>No hace falta que sea perfecto. Solo que sea real.</p>
            <button className="td-glow-btn" onClick={handleEscribir} style={{
              background:C.logoGrad, color:'#fff', border:'none', borderRadius:50,
              padding:'12px 32px', fontSize:15, fontWeight:500, cursor:'pointer', fontFamily:font,
              boxShadow:'0 4px 15px rgba(83,74,183,0.2)',
            }}>Escribir historia</button>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer style={{ borderTop:`0.5px solid ${t.border}`, padding:'2rem 1.5rem', textAlign:'center' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, marginBottom:8 }}>
          <div style={{ width:24, height:24, borderRadius:'50%', background:C.logoGrad, display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ color:'#fff', fontSize:8, fontWeight:600 }}>T&D</span>
          </div>
          <span style={{ fontSize:13, fontWeight:500, color:t.textSecondary }}>Thinker & Doer</span>
        </div>
        <p style={{ fontSize:12, color:t.textSecondary, margin:'0 0 12px', opacity:0.6 }}>Crecer juntos, sin competir.</p>
        <div style={{ display:'flex', justifyContent:'center', gap:16 }}>
          <a href="/terminos" style={{ fontSize:11, color:'rgba(255,255,255,0.35)', textDecoration:'none' }}>Términos</a>
          <a href="/privacidad" style={{ fontSize:11, color:'rgba(255,255,255,0.35)', textDecoration:'none' }}>Privacidad</a>
        </div>
      </footer>

      {/* MODAL FREE OBSERVER */}
      {showModal && (
        <>
          <div onClick={() => setShowModal(false)} style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.7)', backdropFilter:'blur(8px)', zIndex:9998 }} />
          <div style={{
            position:'fixed', top:'50%', left:'50%', transform:'translate(-50%, -50%)',
            width:'calc(100vw - 3rem)', maxWidth:380, zIndex:9999,
            background:'rgba(255,255,255,0.06)', backdropFilter:'blur(30px)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:20, padding:'2rem 1.5rem', textAlign:'center',
            boxShadow:'0 20px 60px rgba(0,0,0,0.25)',
            borderTop:'3px solid', borderImage:'linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b) 1',
          }}>
            <p style={{ fontSize:28, marginBottom:8 }}>✍️</p>
            <p style={{ fontFamily:serif, fontSize:20, fontWeight:400, marginBottom:8 }}>Las mejores historias las escriben quienes se atreven.</p>
            <p style={{ fontSize:14, color:t.textSecondary, lineHeight:1.7, marginBottom:24 }}>
              Únete a Doer para compartir la tuya. Tu historia puede ser exactamente lo que alguien necesita leer.
            </p>
            <button className="td-glow-btn" onClick={() => navigate('/')} style={{
              background:C.logoGrad, color:'#fff', border:'none', borderRadius:50,
              padding:'12px 28px', fontSize:15, fontWeight:500, cursor:'pointer', fontFamily:font, marginBottom:10, width:'100%',
            }}>Ver membresías</button>
            <button onClick={() => setShowModal(false)} style={{
              background:'none', border:'none', color:t.textSecondary, fontSize:13, cursor:'pointer', fontFamily:font,
            }}>Seguir leyendo</button>
          </div>
        </>
      )}
    </div>
  );
}
